import React from 'react'

import { DisplayScreen } from '@store/types'

import Spinner from '@components/ui/spinner'

import { MultiWindowSvg, PushToScreenSvg } from '@svg/react'

import { actionIconProps } from '../../constants'
import { DisplayScreenStateMap } from '../../types'

interface DisplaySessionSectionActionButtonsProps {
  displayScreen: DisplayScreen
  mirroringScreens: DisplayScreenStateMap
  mirroringLoading: DisplayScreenStateMap
  pushToScreenLoading: DisplayScreenStateMap
  onMirroring: (displaySession: DisplayScreen) => void
  onPushToScreen: (displaySession: DisplayScreen) => void
}

function DisplayScreenActions({
  displayScreen,
  mirroringScreens,
  mirroringLoading,
  pushToScreenLoading,
  onMirroring,
  onPushToScreen,
}: DisplaySessionSectionActionButtonsProps) {
  const { masterKey } = displayScreen

  const isMirroring = !!mirroringScreens[masterKey]
  const isMirroringLoading = !!mirroringLoading[masterKey]
  const isPushToScreenLoading = !!pushToScreenLoading[masterKey]
  const isActionDisabled = isMirroringLoading || isPushToScreenLoading

  return (
    <div className="relative h-[50px]">
      <div
        className={`grid h-full grid-cols-2 gap-0 transition-opacity duration-300 ${
          isMirroring ? 'pointer-events-none opacity-0' : 'opacity-100'
        }`}
      >
        {/* Mirror Button */}
        <button
          type="button"
          onClick={() => onMirroring(displayScreen)}
          disabled={isActionDisabled}
          className={`flex flex-col items-center justify-center gap-[2px] border-r border-[rgba(255,255,255,0.25)] bg-[rgba(3,141,254,0.50)] px-3 transition-colors ${
            isActionDisabled
              ? 'cursor-not-allowed, opacity-80'
              : 'hover:bg-[rgba(3,141,254,1)]'
          }`}
        >
          {isMirroringLoading ? (
            <Spinner />
          ) : (
            <>
              <MultiWindowSvg {...actionIconProps} />
              <span className="text-[15px] font-semibold leading-[18px] text-white">
                Mirror
              </span>
            </>
          )}
        </button>

        {/* Push to Screen Button */}
        <button
          type="button"
          onClick={() => onPushToScreen(displayScreen)}
          disabled={isActionDisabled}
          className={`flex flex-col items-center justify-center gap-[2px] bg-[rgba(3,141,254,0.50)] px-3 transition-colors ${isActionDisabled ? 'cursor-not-allowed opacity-80' : 'hover:bg-[rgba(3,141,254,1)]'}`}
        >
          {isPushToScreenLoading ? (
            <Spinner />
          ) : (
            <>
              <PushToScreenSvg {...actionIconProps} />
              <span className="text-[15px] font-semibold leading-[18px] text-white">
                Push to Screen
              </span>
            </>
          )}
        </button>
      </div>

      {/* Stop Mirroring Button */}
      <button
        type="button"
        onClick={() => onMirroring(displayScreen)}
        disabled={isMirroringLoading}
        className={`absolute inset-0 flex h-full w-full origin-left transform flex-col items-center justify-center gap-[2px] bg-[rgba(205,50,65,1)] px-3 transition-transform duration-500 ease-out ${
          isMirroring ? 'scale-x-100' : 'pointer-events-none scale-x-0'
        } ${isMirroringLoading ? 'cursor-not-allowed' : ''}`}
      >
        {isMirroringLoading ? (
          <Spinner />
        ) : (
          <>
            <MultiWindowSvg {...actionIconProps} />
            <span className="text-[15px] font-semibold leading-[18px] text-white">
              Stop mirroring
            </span>
          </>
        )}
      </button>
    </div>
  )
}

export default DisplayScreenActions
